export const BASE_URL = "https://portal.cspmeds.com/api/";
export const PRINT_URL = BASE_URL.replace('/api/','');
export const AS2_DOWNLOAD_URL ="https://prodas2interfaces-eastus2-dbeqaba4breadmhk.eastus2-01.azurewebsites.net/as2/download/";
export const VIDEOS_API_URL ="https://prodas2interfaces-eastus2-dbeqaba4breadmhk.eastus2-01.azurewebsites.net/api/";